import { ModuleContainerGeneric } from '@bpba/modules-components';
import styled from 'styled-components';

// Define the styled component using CSSObject syntax
export const StyledModuleContainerGeneric = styled(ModuleContainerGeneric)({
  div: {
    outline: 'none !important',
  },
});
